// extracted by mini-css-extract-plugin
export var editButton = "_mr-0";